var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { lighten, Chip as MUIChip, chipClasses as MUIchipClasses, styled } from '@mui/material';
const Chip = styled((_a) => {
    var { variant = 'two-tone' } = _a, props = __rest(_a, ["variant"]);
    return (_jsx(MUIChip, Object.assign({ variant: variant }, props)));
})(({ theme, color }) => {
    return {
        [`&.${MUIchipClasses.root}`]: {
            borderRadius: theme.shape.borderRadius,
            paddingInline: theme.spacing(0.75),
            paddingBlock: theme.spacing(0.5),
            gap: theme.spacing(1),
            fontSize: theme.typography['uikit-subheader3'].fontSize,
            fontWeight: theme.typography['uikit-subheader3'].fontWeight,
        },
        [`& .${MUIchipClasses.label}`]: {
            paddingLeft: 0,
            paddingRight: 0,
        },
        [`& .${MUIchipClasses.deleteIcon}, .${MUIchipClasses.icon}`]: {
            margin: 0,
        },
        [`&.${'MuiChip-two-tone'}`]: {
            [`&.${MUIchipClasses.root}`]: {
                backgroundColor: lighten(theme.palette[color].main, 0.9),
                borderColor: lighten(theme.palette[color].main, 0.75),
                borderStyle: 'solid',
                borderWidth: 1,
            },
            [`& .${MUIchipClasses.label}`]: {
                color: theme.palette[color].main,
            },
            [`& .${MUIchipClasses.deleteIcon}, .${MUIchipClasses.icon}`]: {
                color: theme.palette[color].main,
            },
            [`& .${MUIchipClasses.deleteIcon}`]: {
                '&:hover': {
                    color: theme.palette[color].dark,
                },
            },
        },
    };
});
export default Chip;
